/* unplugin-vue-components disabled */import script from "./CourseDialog.vue?vue&type=script&setup=true&name=CourseDialog&lang=js"
export * from "./CourseDialog.vue?vue&type=script&setup=true&name=CourseDialog&lang=js"

import "./CourseDialog.vue?vue&type=style&index=0&id=361b61b1&lang=scss"

const __exports__ = script;

export default __exports__